import { Flex, HStack, IconButton, Text, useClipboard } from '@chakra-ui/react';
import { CopyOutline, CopySuccessOutline } from '@aslanpay/portal-common-lib';

interface TextWithClipboardProps {
  value: string;
  truncate?: boolean;
  addVerticalSpacing?: boolean;
  justifyContent?: string;
  textStyle?: string;
}

function TextWithClipboard({
  value,
  truncate = true,
  addVerticalSpacing = false,
  justifyContent = undefined,
  textStyle = 'smallRegular',
}: TextWithClipboardProps) {
  const { onCopy, hasCopied } = useClipboard(value);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();

    onCopy();
  };

  const Icon = hasCopied ? CopySuccessOutline : CopyOutline;

  return (
    <HStack>
      <Flex justifyContent={justifyContent} align="center" gap="8px" w="100%">
        <Text
          textStyle={textStyle}
          color="gray.900"
          title={value}
          maxW={truncate ? '80px' : 'none'}
          isTruncated={truncate}
          paddingTop={addVerticalSpacing ? '10px' : '0px'}
        >
          {hasCopied ? 'Copied!' : value}
        </Text>
        <IconButton
          aria-label="Copy"
          variant="link"
          size="xs"
          icon={<Icon boxSize="16px" />}
          onClick={handleCopy}
        />
      </Flex>
    </HStack>
  );
}

export default TextWithClipboard;
